import { useAuth } from "@/lib/auth";
import TopBar from "@/components/TopBar";
import BackButton from "@/components/BackButton";
import { ReferralCard } from "@/components/ReferralCard";
import { Instagram, Sparkles } from "lucide-react";

export default function ReferralCardPage() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div data-testid="referral-card-page" className="min-h-screen pb-24">
      <TopBar subtitle="Invite card"/>
      <div className="max-w-2xl mx-auto px-4 pt-4 space-y-5">
        <BackButton fallback="/app/referral" label="Back"/>
        <div className="rounded-2xl border border-[#DC2626]/30 bg-gradient-to-br from-[#DC2626]/10 to-[#180D0D] p-5">
          <p className="text-xs uppercase tracking-[0.2em] text-[#DC2626] mb-1 flex items-center gap-1">
            <Sparkles size={12}/> Bring 5 friends
          </p>
          <h1 className="font-display text-2xl font-bold">Share this card. <span className="gold-text">Unlock Plus.</span></h1>
          <p className="text-sm text-zinc-300 mt-2 leading-relaxed">5 signups with your code → 30 days of Plus, auto-activated.</p>
        </div>

        <ReferralCard user={user}/>

        <div className="rounded-2xl border border-zinc-800 bg-[#180D0D] p-5 text-sm text-zinc-300 leading-relaxed">
          <p className="font-semibold text-white mb-2 flex items-center gap-2"><Instagram size={16} className="text-[#DC2626]"/> How to share</p>
          <ol className="space-y-1 list-decimal ml-5 text-zinc-400">
            <li>Tap <strong className="text-white">Download</strong>.</li>
            <li>Open Instagram, WhatsApp status or any story tool.</li>
            <li>Post the card and mention <strong className="text-white">nextscene.in</strong>.</li>
            <li>Your friends type <strong className="text-[#DC2626]">{user.referral_code}</strong> at signup.</li>
          </ol>
        </div>
      </div>
    </div>
  );
}
